module.exports = "/assets/9c085d2e911ccfa3f4aadec42f5d34fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2I.png
// module id = 984
// module chunks = 0